import { call, put, takeEvery } from "redux-saga/effects";
import { keHoachKyHieuApi } from "../../../api/ke-hoach/keHoachKyHieuApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { IKeHoachKyActionTypes } from "../../action-types/ke-hoach/IKeHoachKyActions";
import { eKeHoachKyHieuActionIds } from "../../action-types/ke-hoach/IKeHoachKyHieuActions";
import { rootActions } from "../../actions/rootActions";

export function* keHoachKyHieuSaga(): any {
    yield takeEvery(eKeHoachKyHieuActionIds.LOAD_START, loadWorker);
}

function* loadWorker(action: IKeHoachKyActionTypes): any {
    const res: IBaseRespone = yield call(keHoachKyHieuApi.SelectAll);
    if (res.is_success) {
        yield put(rootActions.keHoach.kyHieu.LOAD_SUCCESS(res.data));
    } else {
        yield put(
            rootActions.keHoach.kyHieu.LOAD_ERRR(res.message ?? "Có lỗi")
        );
    }
}
